import styled from "styled-components";
import Color from "../../../assets/styles/colors";

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const TitleAlert = styled.span`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackFive
      : Color.textColorBlackOne};
`;

export const IconAlert = styled.i`
  vertical-align: sub;
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.textColorBlackTow : Color.colorBlueCard};
`;
